export * from './services';
import Path from './path';
export default { Path };
